// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ChangeShipTo: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13">
            <path
                fill="currentColor"
                d="M8.25000036,0 L1.5,0 C0.67148459,0 0,0.671484232 0,1.5 L0,10.5 C0,11.3285158 0.67148459,12 1.5,12 L8.25000036,12 C9.07851613,12 9.75000036,11.3285158 9.75000036,10.5 L9.75000036,1.5 C9.75000036,0.671484232 9.07734382,0 8.25000036,0 Z M4.87500036,3 C5.70351613,3 6.37500036,3.67148423 6.37500036,4.5 C6.37500036,5.32851577 5.70351613,6 4.87500036,6 C4.04671919,6 3.37500036,5.32851577 3.37500036,4.5 C3.37500036,3.67148423 4.04765654,3 4.87500036,3 Z M7.12500036,9 L2.62500036,9 C2.41875029,9 2.25000036,8.83124971 2.25000036,8.625 C2.25000036,7.58906221 3.08906293,6.75 4.12500036,6.75 L5.62500036,6.75 C6.66046894,6.75 7.50000036,7.58953142 7.50000036,8.625 C7.50000036,8.83124971 7.33125007,9 7.12500036,9 Z M10.8750004,1.5 L10.5000004,1.5 L10.5000004,3.75 L10.8750004,3.75 C11.0812501,3.75 11.2500004,3.58124971 11.2500004,3.375 L11.2500004,1.875 C11.2500004,1.66781259 11.0812501,1.5 10.8750004,1.5 Z M10.8750004,4.5 L10.5000004,4.5 L10.5000004,6.75 L10.8750004,6.75 C11.0812501,6.75 11.2500004,6.58124971 11.2500004,6.375 L11.2500004,4.875 C11.2500004,4.66874993 11.0812501,4.5 10.8750004,4.5 Z M10.8750004,7.5 L10.5000004,7.5 L10.5000004,9.75 L10.8750004,9.75 C11.0820941,9.75 11.2500004,9.58209372 11.2500004,9.375 L11.2500004,7.875 C11.2500004,7.66875029 11.0812501,7.5 10.8750004,7.5 Z"
                transform="translate(.75 .5)"
            />
        </svg>
    );
};

export default React.memo(ChangeShipTo);
